export enum AppwriteMigrationResource {
    User = 'user',
    Team = 'team',
    Membership = 'membership',
    Database = 'database',
    Table = 'table',
    Column = 'column',
    Index = 'index',
    Row = 'row',
    Document = 'document',
    Attribute = 'attribute',
    Collection = 'collection',
    Documentsdb = 'documentsdb',
    Vectorsdb = 'vectorsdb',
    Bucket = 'bucket',
    File = 'file',
    Function = 'function',
    Deployment = 'deployment',
    Environmentvariable = 'environment-variable',
    Provider = 'provider',
    Topic = 'topic',
    Subscriber = 'subscriber',
    Message = 'message',
    Site = 'site',
    Sitedeployment = 'site-deployment',
    Sitevariable = 'site-variable',
}